import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CreatorAds } from "@/components/CreatorAds";
import { BrandShortcutBar } from "@/components/BrandShortcutBar";

export function MyAds({ onManageSocials }) {
  const [captions, setCaptions] = useState(null);
  const [favourites, setFavourites] = useState([]);
  useEffect(() => {
    api.get("/admin/ad-captions").then(({ data }) => { setCaptions(data.captions); setFavourites(data.favourites); }).catch(() => setCaptions({}));
  }, []);
  const store = captions && {
    captions, favourites,
    setCaption: (k, v) => setCaptions((c) => ({ ...c, [k]: v })),
    addFav: (f) => setFavourites((x) => [f, ...x]),
    removeFav: (id) => setFavourites((x) => x.filter((f) => f.id !== id)),
  };
  return (
    <div data-testid="my-ads-panel" className="space-y-8">
      <BrandShortcutBar onManage={onManageSocials} />
      <p className="text-sm text-text-muted">All your ads in one place. Pick a size, adjust the caption if you like, then share to Instagram, X, WhatsApp or Telegram. Each platform gets its own tracked link, so you can see sign-ups per platform under Marketing.</p>
      {!store ? <p className="text-text-muted">Loading…</p> : (
        <>
          <CreatorAds kind="member" store={store} />
          <CreatorAds store={store} />
        </>
      )}
    </div>
  );
}
